import moment from 'moment';
import { tracking, PubSub, _t, ModalManager } from '@bark/bark-core';
import ResponseStatusSelect from '../../helpers/response_status_select';
import ResponseStatusFeedbackModal from './seller_response_status_feedback_modal';
import {_n} from "@bark/bark-core/src/helpers/number-formatting";
import { getLocalEstimateValue, getLocalEstimateString } from '../estimate/send_estimate';
import {triggerEnquiriesBanner} from "../index";
import { launchBookingDetails } from './booking-details';

export function SellerResponses() {
	const modalManager = new ModalManager();
	const { Handlebars } = window;
    const showNewHeader = Boolean(parseInt(document.getElementById('js-show-new-header')?.value)) ?? false;
    const headerTemplateId = showNewHeader ? 'items-header-template-new-ui' : 'items-header-template'
	let hideAndResetInvoiceGeneratorForm, initNewInvoiceGeneratorForm, previewInvoiceCallback, sellerSelf, refetchInvoicesList;

	Bark.api(
		'seller/self?origin=' + (Bark.isMobile() ? 'mobileweb' : 'desktop'),
		{},
		function (sellerSelfData) {
			sellerSelf = sellerSelfData.data;
		},
	);

	const filtersModal = Handlebars.compile(
		document.getElementById('filters-modal-template').innerHTML,
	);
	const itemsHeaderTemplate = Handlebars.compile(
		document.getElementById(headerTemplateId).innerHTML,
	);
	const projectSummaryTemplate = Handlebars.compile(
		document.getElementById('project-summary-template').innerHTML,
	);
	const projectSummaryTemplateV2 = Handlebars.compile(
		document.getElementById('project-summary-template-v2').innerHTML,
	);
	const projectFullTemplate = Handlebars.compile(
		document.getElementById('project-full-template').innerHTML,
	);
	const projectFullTemplateV2 = Handlebars.compile(
		document.getElementById('project-full-template-v2').innerHTML,
	);
	const hiredModalTemplate = Handlebars.compile(
		document.getElementById('seller-hired-modal-template').innerHTML,
	);
	const verifiedPhoneNumberTemplate = Handlebars.compile(
		document.getElementById('verified-phone-modal-template').innerHTML,
	);
	const filterTemplates = {
		header: Handlebars.compile(
			document.getElementById('accordian-checkbox-template').innerHTML,
		),
		header_radio: Handlebars.compile(
			document.getElementById('accordian-radios-template').innerHTML,
		),
		grouped_checkbox: Handlebars.compile(
			document.getElementById('grouped-checkbox-filter-template').innerHTML,
		),
		checkbox: Handlebars.compile(
			document.getElementById('checkbox-filter-template').innerHTML,
		),
		radio: Handlebars.compile(document.getElementById('radio-filter-template').innerHTML),
	};
	let isEnquiriesActiveCheck = null;

	let ChildFilter = {
		parentStateIgnore: false,
		showCount: function () {
			if (this.count === null) {
				return false;
			}
			return this.displaysCount;
		},
		isDisabled: function () {
			return this.getState() !== 1 && this.showCount() && this.getCount() === 0;
		},
		typeTemplateData: function () {
			return {
				filter_key: this.filterKey,
				filter_value: this.filterValue,
				state: this.getState(),
				disabled: this.isDisabled(),
			};
		},
		bindListeners: function () {
			// as this needs to be registered before render, will need to attach document
			$(document).on('change', '#' + this.id, (e) => {
				if ($(e.currentTarget).prop('checked')) {
					this.activate();
				} else {
					this.deactivate();
				}
				this.fireEvent('state-change', this);
			});
		},
	};

	function GroupCheckboxFilter(rawData) {
		Filter.call(this);
		var instanceVars = {
			parentStateIgnore: true,
			filterType: 'grouped_checkbox',
			filterKey: '',
			filterValue: '',
			state: 0,
			indeterminate: false,
			activate: () => {
				$.each(this.children, (index, child) => {
					if (child.getCount() > 0) {
						child.activate();
					}
				});
			},
			deactivate: () => {
				$.each(this.children, (index, child) => {
					child.deactivate();
				});
			},
			setTypeData: (rawData) => {
				this.filterKey = rawData.filter_key;
				this.filterValue = rawData.filter_value;
			},
			getState: () => {
				let maxCount = this.children.reduce((total, child) => {
					const incr = child.getCount() > 0 ? 1 : 0;
					total = total + incr;
					return total;
				}, 0);
				let stateCount = this.children.reduce((total, child) => {
					total = total + child.getState();
					return total;
				}, 0);
				this.indeterminate = false;
				if (stateCount === 0) {
					return 0;
				} else if (stateCount === maxCount) {
					return 1;
				}
				this.indeterminate = true;
				return 0;
			},
			shouldGetChildrenFilterData: () => {
				return this.getState() !== 1;
			},
			onChildStateChange: (child) => {
				this.fireEvent('state-change', this);
			},
			onRender: () => {
				if (this.hasChildren()) {
					$.each(this.children, (index, child) => {
						child.onRender();
					});
				}
				if (this.indeterminate === true) {
					$('#' + this.id).prop('indeterminate', true);
				} else {
					$('#' + this.id).prop('indeterminate', false);
				}
			},
		};

		Object.assign(this, ChildFilter, instanceVars);
		this.init(rawData);
		return this;
	}

	async function isEnquiriesActive() {
		if (isEnquiriesActiveCheck !== null) {
			return isEnquiriesActiveCheck;
		}

		await Bark.api(
			'lead-settings/lead-settings?filter_type=enquiry',
			{},
			({ data }) => {
				isEnquiriesActiveCheck = data.length > 0 ? true : false;
			},
			() => {
				isEnquiriesActiveCheck = false;
			},
			'GET',
		);
		return isEnquiriesActiveCheck;
	}

	function CheckboxFilter(rawData) {
		Filter.call(this);
		var instanceVars = {
			filterType: 'checkbox',
			filterKey: '',
			filterValue: '',
			setTypeData: (rawData) => {
				this.filterKey = rawData.filter_key;
				this.filterValue = rawData.filter_value;
			},
		};
		Object.assign(this, ChildFilter, instanceVars);
		this.init(rawData);
		return this;
	}

	function RadioFilter(rawData) {
		Filter.call(this);
		var instanceVars = {
			filterType: 'radio',
			defaultSelected: false,
			filterKey: '',
			filterValue: '',
			setTypeData: (rawData) => {
				this.defaultSelected = rawData.default_selected;
				this.filterKey = rawData.filter_key;
				this.filterValue = rawData.filter_value;
			},
		};

		Object.assign(this, ChildFilter, instanceVars);
		this.init(rawData);
		return this;
	}

	function Filter() {
		var instanceVars = {
			filterType: '', // set by child class
			id: '',
			title: '',
			children: [],
			count: null,
			displaysCount: true,
			template: null,
			containerId: '',
			originalState: 0,
			state: 0,
			init: (rawData) => {
				this.setBaseData(rawData);
				this.setTypeData(rawData);
				if (typeof rawData.children !== 'undefined') {
					this.updateChildren(rawData.children);
				}
				this.setTemplate(this.filterType);
				this.bindListeners();
			},
			update: (rawData) => {
				if (typeof rawData.count !== 'undefined') {
					this.count = rawData.count;
				}
				if (typeof rawData.children !== 'undefined') {
					this.updateChildren(rawData.children);
				}
				this.redraw();
			},
			setBaseData: (rawData) => {
				this.id = rawData.id;
				this.containerId = this.id + '-container';
				this.title = rawData.title;
				if (typeof rawData.count !== 'undefined') {
					this.count = rawData.count;
				}
			},
			setTemplate: (templateType) => {
				this.template = filterTemplates[templateType];
			},
			setTypeData: (rawData) => {
				// implemented by child class
			},
			getContainer: () => {
				return $('#' + this.containerId);
			},
			childExists: (childId) => {
				let foundChild = null;
				$.each(this.children, (index, child) => {
					if (child.getId() === childId) {
						foundChild = child;
					}
				});
				return foundChild;
			},
			updateChildren: (childrenData) => {
				if (!Array.isArray(childrenData)) {
					childrenData = [childrenData];
				}
				$.each(childrenData, (index, childData) => {
					let foundChild = this.childExists(childData.id);
					if (foundChild) {
						foundChild.update(childData);
					} else {
						this.addChild(childData);
					}
				});
				this.postUpdateChildren();
			},
			postUpdateChildren: () => {
				// child class can implement
			},
			getFilterData: (ignoreDefault, data) => {
				if (typeof ignoreDefault === 'undefined') {
					ignoreDefault = false;
				}
				if (typeof data === 'undefined') {
					data = {};
				}
				if (this.getState() === 1 && (!ignoreDefault || !this.defaultSelected)) {
					if (this.filterKey in data) {
						data[this.filterKey].push(this.filterValue);
					} else {
						data[this.filterKey] = [this.filterValue];
					}
				}
				if (this.hasChildren() && this.shouldGetChildrenFilterData()) {
					$.each(this.children, (index, child) => {
						child.getFilterData(ignoreDefault, data);
					});
				}
				return data;
			},
			shouldGetChildrenFilterData: () => {
				return true;
			},
			deactivateAll: () => {
				this.deactivate();
				$.each(this.children, (index, child) => {
					child.deactivateAll();
				});
				this.redraw();
			},
			addChild: (childData) => {
				let child = this.createFilter(childData);
				child.on('state-change', this.onChildStateChange);
				this.children.push(child);
			},
			activate: () => {
				this.state = 1;
			},
			deactivate: () => {
				this.state = 0;
			},
			getState: () => {
				return this.state;
			},
			onChildStateChange: (child) => {
				this.fireEvent('filter-change', this);
				this.redraw();
			},
			getId: () => {
				return this.id;
			},
			getType: () => {
				return this.filterType;
			},
			hasChildren: () => {
				return this.children.length > 0;
			},
			getCount: () => {
				return this.count;
			},
			showCount: () => {
				return this.displaysCount;
			},
			createFilter: (rawData) => {
				let obj = null;
				switch (rawData.type) {
					case 'grouped_checkbox':
						obj = GroupCheckboxFilter;
						break;
					case 'checkbox':
						obj = CheckboxFilter;
						break;
					case 'radio':
						obj = RadioFilter;
						break;
					default:
						return false;
						break;
				}
				return new obj(rawData);
			},
			templateData: () => {
				let { id, title } = this;
				let data = {
					id,
					title,
					count: this.getCount(),
					show_count: this.showCount(),
					...this.typeTemplateData(),
				};
				return data;
			},
			typeTemplateData: () => {
				// template data specific to type
				return {};
			},
			apply: () => {
				this.originalState = this.state;
				$.each(this.children, (index, child) => {
					child.apply();
				});
			},
			revert: () => {
				this.state = this.originalState;
				$.each(this.children, (index, child) => {
					child.revert();
				});
				this.redraw();
			},
			render: (fireEvent) => {
				//Hide response status filters since they are applied through the tabs.
				if (this.getId() == 'response-status') {
					return;
				}

				if (typeof fireEvent === 'undefined') {
					fireEvent = true;
				}
				let childrenHtml = $.map(this.children, (child) => {
					return child.render();
				}).join(' ');
				let templateData = {
					...this.templateData(),
					children_html: childrenHtml,
				};
				if (fireEvent) {
					this.onRender();
				}
				return this.template(templateData);
			},
			redraw: () => {
				this.getContainer().replaceWith(this.render(false));
				this.onRender();
			},
			onRender: () => {
				if (this.hasChildren()) {
					$.each(this.children, (index, child) => {
						child.onRender();
					});
				}
			},
			bindListeners: () => {
				// implemented by child classes
			},
		};

		Object.assign(this, PubSub, instanceVars);
		return this;
	}

	function ProjectFile(fileData) {
		let instanceVars = {
			truncateLength: 6,
			extension: '',
			path: '',
			filename: '',
			init: (fileData) => {
				this.extension = fileData.extension;
				this.path = fileData.path;
				this.filename = this.path.replace(/.*\//, '');
			},
			getPath: () => {
				return this.path;
			},
			getBasename: () => {
				return this.filename.replace('.' + this.extension, '');
			},
			getAttachmentAsset: (fileExtension) => {
				let basePath =
					'https://d18jakcjgoan9.cloudfront.net/img/barkv2/material-icons/filetype_';
				let type = '';
				switch (fileExtension) {
					case 'doc':
					case 'docx':
					case 'pages':
						type = 'doc';
						break;
					case 'jpg':
					case 'jpeg':
						type = 'jpg';
						break;
					case 'gif':
						type = 'gif';
						break;
					case 'png':
						type = 'png';
						break;
					case 'pdf':
						type = 'PDF';
						break;
					case 'zip':
						type = 'zip';
						break;
					default:
						type = 'other';
						break;
				}
				return basePath + type + '.svg';
			},
			truncateFileName: () => {
				let basename = this.getBasename();
				if (basename.length > this.truncateLength) {
					basename = basename.substr(0, this.truncateLength - 1) + '&hellip;';
				}
				let extension = this.extension ? this.extension.toLowerCase() : '';
				return basename + extension;
			},
			getTemplateData: () => {
				return {
					path: this.path,
					filetype_image: this.getAttachmentAsset(this.extension),
					filename: this.truncateFileName(),
				};
			},
		};
		Object.assign(this, instanceVars);
		this.init(fileData);
		return this;
	}

	function Item(rawItem) {
		let instanceVars = {
			template: null,
			maxActionLength: 70,
			className: '',
			rendered: false,

			projectId: null,
			buyerId: null,
			responseId: null,
			slug: '',
			buyerName: '',
			buyerSupportedSmsType: 'none',
			isBuyerPhoneVerified: false,
			matchType: null,
			isRead: false,
			title: '',
			summary: '',
			location: '',
			telephone: '',
			email: '',
			lastAction: {},
			responseStatus: null,
			projectStatus: null,
			response_ago: null,
			created: null,
			images: [],
			hasPhoned: false,
			sentSMS: false,
			sentEmail: false,
			note: '',
			currency: '',
			quoteValue: false,
			quoteFrequency: '',
			hasHiredSellerData: false,
			isUrgent: false,
			isEnquiry: false,
			isMarketplaceBooking: false,
			isMarketplaceEnquiry: false,
			isMessageEnquiry: false,
			buyerIsEnquiry: false,
			contactPreferences: false,
			init: (rawItem) => {
				this.mapData(rawItem);
			},
			mapData: (rawItem) => {
				this.projectId = rawItem.project_id;
				this.buyerId = rawItem.buyer_user_id;
				this.responseId = rawItem.resp_id;
				this.slug = rawItem.slug;
				this.buyerName = rawItem.buyer_share_name;
				(this.buyerSupportedSmsType = rawItem.buyer_supported_sms_type || 'none'),
					(this.isRead = rawItem.viewed);
				this.isBuyerPhoneVerified = rawItem.is_buyer_phone_verified;
				this.setCustomerOrder(rawItem.customer_order || null);
				this.matchType = rawItem.match_type;
				this.customer_order = rawItem.customer_order;
				this.isEnquiry = rawItem.match_type === 'enquiry';
				this.isMarketplaceBooking = rawItem.match_type === 'marketplace-booking';
				this.isMarketplaceEnquiry = rawItem.match_type === 'marketplace-enquiry';
				this.isMessageEnquiry = rawItem.match_type === 'marketplace-messages';
				this.buyerIsEnquiry =
					this.isEnquiry ||
					this.isMarketplaceBooking ||
					this.isMarketplaceEnquiry ||
					this.isMessageEnquiry;
				this.title = rawItem.project_title;
				this.summary = rawItem.summary;
				this.location = rawItem.city_string;
				this.telephone = rawItem.buyer_telephone;
				this.telephoneFormatted = rawItem.buyer_telephone_formatted;
				this.email = rawItem.buyer_email;
				if (rawItem.last_message) {
					this.lastAction = {
						message: rawItem.last_message.label,
						time: moment(rawItem.last_message.time * 1000),
						isSeller: rawItem.last_message.sender === 'seller',
					};
				}
				this.responseStatus = rawItem.response_status_id;
				this.responseStatusLastUpdated = rawItem.response_status_last_updated
					? moment.utc(rawItem.response_status_last_updated)
					: null;
				this.projectStatus = rawItem.project_status;
				this.since = moment.utc(rawItem.since);
				this.created = rawItem.created;
				this.detail = rawItem.project_detail;
				this.qas = rawItem.project_details;
				this.geo = {
					lat: rawItem.latitude,
					lng: rawItem.longitude,
				};
				this.images = $.map(rawItem.images, (fileData) => {
					return new ProjectFile({
						extension: fileData.extension,
						path: fileData.image,
					});
				});
				this.files = $.map(rawItem.files, (fileData) => {
					return new ProjectFile({
						extension: fileData.extension,
						path: fileData.path,
					});
				});
				this.hasPhoned = rawItem.has_phoned;
				this.sentSMS = rawItem.sent_sms;
				this.sentEmail = rawItem.sent_email;
				this.note = rawItem.note;
				this.currency = Bark.seller.currencySymbol;
				this.setQuoteData({
					quote: rawItem['quote'],
					quote_type: rawItem['quote_type'],
					quote_detail: rawItem['quote_detail'],
				});
				this.hasHiredSellerData = rawItem.has_hired_seller_data;
				this.isUrgent = rawItem.is_urgent;
				this.contactPreferences = rawItem.contact_preferences;
				this.creditsUsed = rawItem.credits_used;
				this.wasFreeWithSubscription = rawItem.was_free_with_subscription;
				this.creditReturnStatus = rawItem.credit_return_status;
			},
			html: () => {
				this.rendered = true;
				return this.template(this.getTemplateData());
			},
			isRendered: () => {
				return this.rendered;
			},
			setCustomerOrder: (customerOrder) => {
				if (!customerOrder) {
					return;
				}
				const startDate = new Date(customerOrder.start_at);

				this.customerOrder = {
					month: window.Bark.date('M', startDate),
					day: window.Bark.date('j', startDate),
					service_name: customerOrder.job.name,
					num:
						customerOrder.pricing.unit === 'session'
							? 1
							: parseInt(customerOrder.duration / 60),
					rate:
						customerOrder.pricing.unit === 'session'
							? customerOrder.pricing.value
							: customerOrder.pricing.value + '/h',
					unit: customerOrder.pricing.unit,
					currency_symbol: window.Bark.ENV.currency_symbol,
				};
			},
			setQuoteData: (quoteData) => {
				this.quoteValue = quoteData.quote ? quoteData.quote : false;
				this.quoteFrequency = quoteData.quote_type;
				this.quoteDetail = quoteData.quote_detail ? quoteData.quote_detail : '';
			},
			getTruncatedLastActionMessage: () => {
				let lastActionMessage = this.lastAction.message;
				if (lastActionMessage.length > this.maxActionLength) {
					lastActionMessage =
						lastActionMessage.substring(0, this.maxActionLength - 3) + '...';
				}
				return lastActionMessage;
			},
			getLastActionAtFromNow: () => {
				return this.lastAction.time.locale('responses').fromNow();
			},
			getInteractionData: () => {
				return {
					has_phoned: this.hasPhoned,
					sent_sms: this.sentSMS,
					sent_email: this.sentEmail,
					note: this.note,
				};
			},
			getQuoteData: () => {
				return {
					currency: this.currency,
					quote_value: getLocalEstimateValue(this.quoteValue),
					quote_frequency: this.quoteFrequency,
					quote_show_per: this.quoteFrequency !== 'onceoff',
					quote_string: getLocalEstimateString(this.quoteValue, this.quoteFrequency),
				};
			},
			getLastActionData: () => {
				let lastActionData = {};
				if (this.lastAction.message) {
					lastActionData = {
						last_action: this.getTruncatedLastActionMessage(),
						last_action_at: this.getLastActionAtFromNow(),
						last_action_is_seller: this.lastAction.isSeller,
					};
				}
				return lastActionData;
			},
			getProjectId: () => {
				return this.projectId;
			},
			getRenderedElement: () => {
				let $el = null;
				if (this.rendered) {
					$el = $('.' + this.className + '[data-project-id="' + this.projectId + '"]');
				}
				return $el;
			},
			redraw: () => {
				this.getRenderedElement().replaceWith(this.html());
				this.postRender();
				return this;
			},
			postRender: () => {
				// can be implemented by child class
			},
			isResponseStatusIdLive: () => {
				return this.responseStatus == null || this.responseStatus == 1;
			},
			isResponseStatusIdHired: () => {
				return this.responseStatus == 3;
			},
			isResponseStatusIdArchived: () => {
				return this.responseStatus == 2;
			},
		};

		Object.assign(this, instanceVars);
		this.init(rawItem);
		return this;
	}

	function SummaryItem(rawItem) {
		Item.call(this, rawItem);
		const summaryExp = Bark.seller.showNewResponsesUIOct22 ?? false;
		let instanceVars = {
			maxTitleSummaryLength: 75,
			template: summaryExp ? projectSummaryTemplateV2 : projectSummaryTemplate,
			className: 'responses-projects-item',
			selected: false,
			getTemplateData: () => {
				let title = this.title;
				let summary = this.summary;
				if (title.length > this.maxTitleSummaryLength) {
					title = title.substring(0, 75) + '...';
					summary = false;
				} else if (summary) {
					let totalLength = title.length + summary.length + 3;
					if (totalLength > this.maxTitleSummaryLength) {
						let remaining = this.maxTitleSummaryLength - (title.length + 3);
						if (remaining < 3) {
							summary = false;
						} else {
							summary = summary.substring(0, remaining) + '...';
						}
					}
				}
				let contactMethodList = [];
				const hasContactPreferences = this.contactPreferences.length > 0;
				if (hasContactPreferences) {
					['phone', 'sms', 'email'].forEach((slug) => {
						let trans = null;
						switch (slug) {
							case 'phone':
								trans = _t('seller_responses:contact-preferences.contact-methods.phone');
								break;
							case 'email':
								trans = _t('seller_responses:contact-preferences.contact-methods.email');
								break;
							case 'sms':
								trans = _t('seller_responses:contact-preferences.contact-methods.sms');
								break;
						}
						if (this.contactPreferences.includes(slug) !== false) {
							contactMethodList.push(
								$('<span>', { class: 'text-dark-blue text-medium', html: trans }).get(0)
									.outerHTML,
							);
						}
					});
				}
				const contactMethodListText = contactMethodList.join(' / ');
				let contactPreferenceHtml = '';
				if (this.isUrgent) {
					if (hasContactPreferences) {
						contactPreferenceHtml = _t(
							'seller_responses:contact-preferences.urgent-preferences',
							{
								urgently_text: $('<span>', {
									class: 'text-orange text-xs stronger',
									html: _t('seller_responses:contact-preferences.urgently', {
										interpolation: { escapeValue: false },
									}),
								}).get(0).outerHTML,
								preferred_contact_methods_list: contactMethodListText,
								interpolation: { escapeValue: false },
							},
						);
					} else {
						contactPreferenceHtml = _t(
							'seller_responses:contact-preferences.urgent-only',
							{
								urgently_text: $('<span>', {
									class: 'text-orange text-xs stronger',
									html: _t('seller_responses:contact-preferences.urgently', {
										interpolation: { escapeValue: false },
									}),
								}).get(0).outerHTML,
								interpolation: { escapeValue: false },
							},
						);
					}
				} else {
					contactPreferenceHtml = _t(
						'seller_responses:contact-preferences.non-urgent-preferences',
						{
							preferred_contact_methods_list: contactMethodListText,
							interpolation: { escapeValue: false },
						},
					);
				}
				return {
					selected: this.selected,
					project_id: this.projectId,
					unread: !this.isRead,
					buyer_name: this.buyerName,
					title: title,
					summary: summary,
					location: this.location,
					isLive: this.isResponseStatusIdLive(),
					isHired: this.isResponseStatusIdHired(),
					isArchived: this.isResponseStatusIdArchived(),
					displayUrgentContactPreferences: hasContactPreferences || this.isUrgent,
					isUrgent: this.isUrgent,
					isEnquiry: this.isEnquiry,
					isMarketplaceBooking: this.isMarketplaceBooking,
					isMarketplaceEnquiry: this.isMarketplaceEnquiry,
					isMessageEnquiry: this.isMessageEnquiry,
					buyerIsEnquiry: this.buyerIsEnquiry,
					contactPreferenceHtml: contactPreferenceHtml,
					customerOrder: this.customerOrder,
					...this.getLastActionData(),
				};
			},
			setSelected: (state) => {
				if (typeof state === 'undefined') {
					state = true;
				}
				this.selected = state;
				if (this.rendered) {
					this.redraw();
				}
				return this;
			},
		};

		Object.assign(this, instanceVars);
		return this;
	}

	function FullItem(rawItem) {
		Item.call(this, rawItem);
		const fullExp = Bark.seller.showNewResponsesUIOct22 ?? false;
		let instanceVars = {
			containerId: 'full-project-container',
			template: fullExp ? projectFullTemplateV2 : projectFullTemplate,
			className: 'responses-project-details',
			messengerLinkClass: 'view-messages',
			estimateLinkClass: 'send-estimate',
			submitNoteLinkClass: 'submit-notes',
			revertNoteLinkClass: 'revert-notes',
			responseContactCheckboxClass: 'response-contact-action',
			projectStatusSelectId: 'project-status-select',
			backToListLinkClass: 'back-to-list',
			quoteLinkClass: 'quote-link',
			verifiedPhoneButtonClass: 'verified-phone-button',
			showHiredSuccess: false,
			responseStatusChanged: false,
			responseStatusClasses: {
				1: ['bg-primary', 'text-white'],
				2: ['bg-secondary', 'text-grey-100'],
				3: ['bg-success', 'text-white'],
			},
			getTemplateData: () => {
				return {
					project_id: this.projectId,
					response_status: this.responseStatus,
					response_status_classes: this.getResponseStatusClasses(this.responseStatus),
					responded_time_ago_text: _t(
						'seller_responses:project-details.responded-time-ago-text',
						{
							time_ago: this.getSinceFromNow(),
						},
					),
					telephone: this.telephone,
					email: this.email,
					unread: !this.isRead,
					buyer_name: this.buyerName,
					is_buyer_phone_verified: this.isBuyerPhoneVerified,
					title: this.title,
					summary: this.summary,
					location: this.location,
					closed: this.projectStatus === 'closed' ? true : false,
					qas: this.qas,
					detail: this.detail.length > 0 ? this.detail : false,
					geo: this.geo,
					show_hired_message: this.showHiredSuccess,
					isLive: this.isResponseStatusIdLive(),
					isHired: this.isResponseStatusIdHired(),
					isArchived: this.isResponseStatusIdArchived(),
					isUrgent: this.isUrgent,
					contactPreferenceHtml: this.getContactPreferenceHtml(),
					displayUrgentContactPreferences:
						this.contactPreferences.length > 0 || this.isUrgent,
					attachments: [...this.getImageData(), ...this.getFileData()],
					creditsUsed: this.getCreditsUsed(),
					isEnquiry: this.isEnquiry,
					isMarketplaceBooking: this.isMarketplaceBooking,
					isMarketplaceEnquiry: this.isMarketplaceEnquiry,
					isMessageEnquiry: this.isMessageEnquiry,
					buyerIsEnquiry: this.buyerIsEnquiry,
					isCallback: this.matchType === 'callback',
					...this.getInteractionData(),
					...this.getLastActionData(),
					...this.getQuoteData(),
				};
			},
			getSinceFromNow: () => {
				return this.since.locale('responses').fromNow();
			},
			getContainer: () => {
				return $('#' + this.containerId);
			},
			render: () => {
				this.getContainer().empty().append(this.html());
				this.postRender();
			},
			redraw: () => {
				this.fireEvent('project-redraw', this);
				this.getRenderedElement().replaceWith(this.html());
				this.postRender();
				return this;
			},
			clear: () => {
				this.getContainer().empty();
			},
			postRender: () => {
				Bark.seller?.CreditsUsed?.render({
					projectResponseId: this.responseId,
					creditsUsed: this.creditsUsed,
					canRequestReturn: this.creditReturnStatus.can_request,
					hasRequestedReturn: this.creditReturnStatus.has_requested,
					returnStatus: this.creditReturnStatus.return_status,
				});
				this.createResponseStatusBar();
				this.updateProjectStatusDropdown();
				this.bindListeners();
				launchBookingDetails(this);
				this.fireEvent('project-rendered', this);
				this.showInvoicesList();
			},
			showDetails: () => {
				$('#details-tab').tab('show');
				let target = $('#response-sections-tabs');
				$('.right-panel').animate(
					{
						scrollTop: target[0].offsetTop,
					},
					500,
				);
			},
			getImageData: () => {
				return $.map(this.images, (imageFile) => {
					return imageFile.getTemplateData();
				});
			},
			getFileData: () => {
				return $.map(this.files, (otherFile) => {
					return otherFile.getTemplateData();
				});
			},
			getCreditsUsed: () => {
				return _t('seller_responses:project-details.credits-used', {
					count: this.creditsUsed,
				});
			},
			getContactPreferenceHtml: () => {
				let contactMethodList = [];
				const hasContactPreferences = this.contactPreferences.length > 0;
				if (hasContactPreferences) {
					['phone', 'sms', 'email'].forEach((slug) => {
						let trans = null;
						switch (slug) {
							case 'phone':
								trans = _t('seller_responses:contact-preferences.contact-methods.phone');
								break;
							case 'email':
								trans = _t('seller_responses:contact-preferences.contact-methods.email');
								break;
							case 'sms':
								trans = _t('seller_responses:contact-preferences.contact-methods.sms');
								break;
						}
						if (this.contactPreferences.includes(slug) !== false) {
							contactMethodList.push(
								$('<span>', { class: 'text-dark-blue text-medium', html: trans }).get(0)
									.outerHTML,
							);
						}
					});
				}
				const contactMethodListText = contactMethodList.join(' / ');
				let contactPreferenceHtml = '';
				if (this.isUrgent) {
					if (hasContactPreferences) {
						contactPreferenceHtml = _t(
							'seller_responses:contact-preferences.urgent-preferences',
							{
								urgently_text: $('<span>', {
									class: 'text-orange text-xs stronger',
									html: _t('seller_responses:contact-preferences.urgently', {
										interpolation: { escapeValue: false },
									}),
								}).get(0).outerHTML,
								preferred_contact_methods_list: contactMethodListText,
								interpolation: { escapeValue: false },
							},
						);
					} else {
						contactPreferenceHtml = _t(
							'seller_responses:contact-preferences.urgent-only',
							{
								urgently_text: $('<span>', {
									class: 'text-orange text-xs stronger',
									html: _t('seller_responses:contact-preferences.urgently', {
										interpolation: { escapeValue: false },
									}),
								}).get(0).outerHTML,
								interpolation: { escapeValue: false },
							},
						);
					}
				} else {
					if (hasContactPreferences) {
						contactPreferenceHtml = _t(
							'seller_responses:contact-preferences.non-urgent-preferences-long',
							{
								preferred_contact_methods_list: contactMethodListText,
								interpolation: { escapeValue: false },
							},
						);
					}
				}
				return contactPreferenceHtml;
			},
			getResponseStatusClasses: (responseStatus) => {
				if (!responseStatus) {
					responseStatus = 1;
				}
				return this.responseStatusClasses[responseStatus].join(' ');
			},
			makeMessengerLink: (estimate) => {
				let qs = '';
				if (estimate) {
					qs = '?send-estimate=1';
				}
				return '/sellers/messenger/' + this.slug + '/' + qs;
			},
			updateNote: () => {
				let newNote = $('.notes-input').val();
				if (newNote === this.note) {
					return true;
				}
				$('.notes-error').text('');
				let $el = $('.' + this.submitNoteLinkClass);
				$el
					.addClass('submitting')
					.prop('disabled', true)
					.find('.submit-text')
					.text(_t('seller_responses:notes.updating-button'));
				Bark.api(
					'response/note/',
					{
						response_id: this.responseId,
						note: newNote,
					},
					(data) => {
						this.note = newNote;
						$el
							.removeClass('btn-primary')
							.addClass('btn-success')
							.removeClass('submitting')
							.find('.submit-text')
							.text(_t('seller_responses:notes.success-button'));

						setTimeout(() => {
							$el
								.removeClass('btn-success')
								.addClass('btn-primary')
								.prop('disabled', false)
								.find('.submit-text')
								.text(_t('seller_responses:notes.update-button'));
						}, 3000);
					},
					(error) => {
						// failed to update on the api, show error message
						$('.notes-error').text(_t('seller_responses:notes.errors.generic'));
						$el.removeClass('submitting').prop('disabled', false);
					},
					'POST',
					{
						Accept: 'application/vnd.bark.v2+json',
					},
				);
			},
			revertNote: () => {
				$('.notes-input').val(this.note);
				$('.notes-error').text('');
			},
			updateResponseContact: (contactType, enabled) => {
				enabled = enabled ? 1 : 0;
				Bark.api(
					'response/contact/',
					{
						response_id: this.responseId,
						type: contactType,
						enabled: enabled,
					},
					(data) => {
						switch (contactType) {
							case 'phone':
								this.has_phoned = enabled;
								break;
							case 'sms':
								this.sent_sms = enabled;
								break;
							case 'email':
								this.sent_email = enabled;
								break;
						}
					},
					(error) => {
						this.redraw();
					},
					'POST',
					{
						Accept: 'application/vnd.bark.v2+json',
					},
				);
			},
			updateProjectStatusDropdown: (changed) => {
				let classes = {
					1: ['bg-primary', 'text-white'],
					2: ['bg-secondary', 'text-grey-100'],
					3: ['bg-success', 'text-white'],
				};
				let protectedClasses = ['custom-select', 'drop-arrow'];
				let $el = $('#' + this.projectStatusSelectId);
				let statusId = parseInt($el.val());
				$el.removeClass();
				$el.addClass(protectedClasses.join(' '));
				$el.addClass(this.getResponseStatusClasses(statusId));
				if (changed) {
					let project_id = this.projectId;
					Bark.api(
						'response/update-seller-status',
						{
							project_id,
							status_id: statusId,
						},
						(data) => {
							this.responseStatus = statusId;
							if (statusId === 3) {
								this.showHiredSuccess = true;
								if (!this.hasHiredSellerData) {
									this.loadHiredModal();
								}
							} else {
								this.showHiredSuccess = false;
							}

							const statusLabel = ['error', 'live', 'archived', 'hired'][statusId];

							tracking('responses-dashboard', 'Mark lead status', {
								project_id,
								status: statusLabel,
								pagename: window.location.pathname,
								lead_type: 'project',
							});

							window.trackProjectHiredStatusChange(statusLabel);

							//Status changed to Archived
							if (statusId === 2) {
								this.loadArchivedFeedbackModal(data, statusId);
							} else {
								//Status changed to Pending or Hired (for Archived, this is called after feedback modal. See above)
								this.refreshAfterStatusUpdate(statusId);
							}
						},
						(error) => {
							console.log('failed', error);
						},
						'POST',
					);
				}
			},
			refreshAfterStatusUpdate: (statusId) => {
				if (this.isMobile()) {
					//Don't refesh list on mobile, instead update this.responseStatusChanged to trigger refresh when 'back to list' is clicked.
					this.responseStatusChanged = true;
					this.responseStatus = statusId;
					this.responseStatusLastUpdated = moment();
					this.redraw();
				} else {
					//Refresh list
					this.fireEvent('response-status-changed');
				}
			},
			createResponseStatusBar: () => {
				ResponseStatusSelect.create(this);
			},
			loadQuoteModal: (e) => {
				let action =
					$(e.target).text().trim() ==
					_t('seller_responses:provide-quote-modal.update-button')
						? _t('seller_responses:provide-quote-modal.update-button')
						: _t('seller_responses:provide-quote-modal.send-button');
				tracking(
					'seller-leads-dashboard-&-responses',
					`${action} reference quote - view`,
					{
						pagename: window.location.pathname,
						project_id: this.projectId,
						project_response_id: this.responseId,
						lead_type: 'project',
					},
				);
				Bark.sendEstimate && Bark.sendEstimate.showModal();
			},
			loadHiredModal: () => {
				modalManager.set(
					false,
					false,
					hiredModalTemplate({
						ask_for_review: _t(
							'seller_responses:hired-modal.input.ask-for-review.label',
							{
								buyer_public_name: this.buyerName,
							},
						),
					}),
					[],
					['hired-modal'],
				);
				modalManager.setEvent('keyup blur', '#hired-amount', {}, (e) => {
					let $input = $(e.currentTarget);
					let $wrapper = $('.hired-amount-value-input');
					if ($input.val().length > 0) {
						$wrapper.addClass('has-value');
					} else {
						$wrapper.removeClass('has-value');
					}
				});
				modalManager.setEvent('click', '#hired-no-disclose', {}, (e) => {
					if ($(e.currentTarget).prop('checked')) {
						$('#hired-amount, #hired-type').prop('disabled', true);
						$('.hired-amount').addClass('disabled');
					} else {
						$('#hired-amount, #hired-type').prop('disabled', false);
						$('.hired-amount').removeClass('disabled');
					}
				});
				modalManager.setEvent('submit', '#seller-hired-form', {}, (e) => {
					e.preventDefault();
					this.processHiredModal();
					this.showInvoiceGeneratorStartModal();
					return false;
				});
				modalManager.setEvent('click', '.close.close-modal-cross', {}, (e) => {
					this.showInvoiceGeneratorStartModal();
				});
			},
			loadVerifiedPhoneModal: () => {
				// SellerViewBuyerPhoneVerificationExperiment: show the explainer modal
				Bark.logEvent(
					'show-buyer-phone-verified-modal',
					'click',
					'phone-verified-responses',
				);
				modalManager.set(
					_t('seller_responses:verified-phone-modal.title'),
					null,
					verifiedPhoneNumberTemplate({}),
					[],
					['verified-phone-modal', 'reduced-padding-header'],
				);
			},
			loadArchivedFeedbackModal: (data, statusId) => {
				data.project_response_id = this.responseId;
				data.status_id = statusId;
				let responseStatusFeedbackModal = ResponseStatusFeedbackModal();
				responseStatusFeedbackModal.init(data, this.refreshAfterStatusUpdate);
			},
			processHiredModal: () => {
				let $modal = $('#sellerHiredModal');
				let noDisclosure = $modal.find('#hired-no-disclose').prop('checked');
				$modal.find('.error').addClass('d-none');
				if (!noDisclosure) {
					if (!$modal.find('#hired-amount').val()) {
						$modal.find('#hired-modal-amount-error').removeClass('d-none');
						return false;
					} else if (!$('#hired-type').val()) {
						$modal.find('#hired-modal-type-error').removeClass('d-none');
						return false;
					}
				}
				let payload = {
					bid: this.projectId,
					quote: noDisclosure ? 0 : $modal.find('#hired-amount').val(),
					qtype: noDisclosure ? 'onceoff' : $modal.find('#hired-type').val(),
					review: $modal.find('#hired-review').prop('checked') ? 1 : 0,
					nodisc: noDisclosure ? 1 : 0,
				};
				$('#hired-submit').prop('disabled', true).addClass('submitting');
				Bark.api(
					'seller/project-hired/',
					payload,
					(data) => {
						this.hasHiredSellerData = true;
						modalManager.destroy();
					},
					(error) => {
						if (error.status === 403) {
							// already has hired data
							this.hasHiredSellerData = true;
							modalManager.destroy();
							return;
						}
						$modal.find('#hired-modal-save-error').removeClass('d-none');
						$('#hired-submit').prop('disabled', false).removeClass('submitting');
					},
					'POST',
					Bark.apiVersionHeader('v2'),
				);
			},
			showInvoiceGeneratorStartModal: () => {
				if ($('#invoice-generator-start-modal').length) {
					if (window.SellerResponsesApp) {
						window.SellerResponsesApp.launchModule(
							'invoice-generator-start-modal',
							'invoice-generator-start-modal',
							{
								isOpen: true,
								sellerProfileId: Bark.seller.id,
								buyerName: this.buyerName,
								projectId: this.projectId,
								responseId: this.responseId,
								openInvoiceForm: () => {
									$('#response-hired').click();
									this.showInvoiceGeneratorForm();
								}
							},
						);
					} else {
						tracking(
							'Invoice Generator Start Modal',
							'Seller responses react app not loaded',
						);
					}
				}
			},
			showInvoiceGeneratorForm: (invoiceId) => {
				if ($('#invoice-generator-form').length) {
					if (window.SellerResponsesApp) {
						if (previewInvoiceCallback && invoiceId) {
							previewInvoiceCallback(invoiceId);
						} else if (initNewInvoiceGeneratorForm) {
							initNewInvoiceGeneratorForm(this.projectId, this.buyerName);
						} else {
							window.SellerResponsesApp.launchModule(
								'invoice-generator-form',
								'invoice-generator-form',
								{
									onCancelForm: () => {
										$('#invoice-generator-form').removeClass(
											'position-absolute top-0 left-0 w-100 h-100 zindex-dropdown bg-white',
										);
										refetchInvoicesList?.();
									},
									sellerProfileId: sellerSelf?.spf_id,
									buyerName: this.buyerName,
									projectId: this.projectId,
									businessName: sellerSelf?.company,
									onMount: ({
										hideAndResetForm,
										initNewForm,
										previewInvoice
									}) => {
										initNewInvoiceGeneratorForm = initNewForm;
										hideAndResetInvoiceGeneratorForm = () => {
											hideAndResetForm();
											$('#invoice-generator-form').removeClass(
												'position-absolute top-0 left-0 w-100 h-100 zindex-dropdown bg-white',
											);
										};
										previewInvoiceCallback = previewInvoice;
									},
									initialViewMode: invoiceId ? 'preview' : 'edit',
									invoiceId,
								}
							);
						}
					} else {
						tracking('Invoice Generator Form', 'Seller responses react app not loaded');
					}
					$('#invoice-generator-form').addClass(
						'position-absolute top-0 left-0 w-100 h-100 zindex-dropdown bg-white',
					);
				}
			},
			showInvoicesList: () => {
				if ($('#invoices-list').length) {
					if (window.SellerResponsesApp) {
						window.SellerResponsesApp.launchModule('invoices-list', 'invoices-list', {
							sellerProfileId: sellerSelf?.spf_id,
							projectId: this.projectId,
							openInvoiceForm: () => {
								this.showInvoiceGeneratorForm();
							},
							openInvoicePreview: (invoiceId) => {
								this.showInvoiceGeneratorForm(invoiceId);
							},
							onMount: ({
								refetchAllInvoices,
							}) => {
								refetchInvoicesList = refetchAllInvoices;
							},
						});
					} else {
						tracking('Invoices List', 'Seller responses react app not loaded');
					}
				}
			},
			bindListeners: () => {
				this.getRenderedElement().on('click', '.' + this.messengerLinkClass, (e) => {
					e.preventDefault();
					let sendEstimate = $(e.currentTarget).hasClass(this.estimateLinkClass);
					let target = Bark.isMobile() ? '_self' : '_blank';
					window.open(this.makeMessengerLink(sendEstimate), target);
				});
				this.getRenderedElement().on('click', '.' + this.submitNoteLinkClass, (e) => {
					e.preventDefault();
					this.updateNote();
				});
				this.getRenderedElement().on('click', '.' + this.revertNoteLinkClass, (e) => {
					e.preventDefault();
					this.revertNote();
				});
				this.getRenderedElement().on(
					'change',
					'.' + this.responseContactCheckboxClass,
					(e) => {
						e.preventDefault();
						let $el = $(e.currentTarget);
						this.updateResponseContact(
							$el.data('response-contact-type'),
							$el.is(':checked'),
						);
					},
				);
				this.getRenderedElement().on('change', '#' + this.projectStatusSelectId, (e) => {
					this.updateProjectStatusDropdown(true);
				});
				this.getRenderedElement().on('click', '.' + this.backToListLinkClass, (e) => {
					e.preventDefault();
					this.fireEvent('back-to-list-clicked', this);
				});
				this.getRenderedElement().on('click', '.' + this.quoteLinkClass, (e) => {
					e.preventDefault();
					this.loadQuoteModal(e);
				});
				this.getRenderedElement().on(
					'click',
					'.' + this.verifiedPhoneButtonClass,
					(e) => {
						e.preventDefault();
						this.loadVerifiedPhoneModal();
					},
				);
			},
			isMobile: () => {
				return $(window).width() < 768;
			},
		};

		Object.assign(this, PubSub, instanceVars);
		return this;
	}

	function HeaderFilter(rawData) {
		Filter.call(this);
		var instanceVars = {
			filterType: 'header',
			expanded: false,
			getCount: () => {
				return this.getChildrenStateCount(this);
			},
			getChildrenStateCount: (filter) => {
				return filter.children.reduce((total, child) => {
					if (child.hasChildren()) {
						total = total + this.getChildrenStateCount(child);
					}
					if (child.getState() === 1 && !child.parentStateIgnore) {
						total = total + 1;
					}
					return total;
				}, 0);
			},
			showCount: () => {
				return this.displaysCount && this.getCount();
			},
			setTypeData: (rawData) => {
				this.expanded = rawData.expanded;
			},
			typeTemplateData: () => {
				return {
					expanded: this.expanded,
				};
			},
			bindListeners: () => {
				$(document).on('show.bs.collapse', '#collapse-' + this.id, () => {
					this.expanded = true;
				});
				$(document).on('hide.bs.collapse', '#collapse-' + this.id, () => {
					this.expanded = false;
				});
			},
		};

		Object.assign(this, instanceVars);
		this.init(rawData);
		return this;
	}

	function HeaderRadioFilter(rawData) {
		Filter.call(this);
		var instanceVars = {
			filterType: 'header_radio',
			expanded: false,
			displaysCount: false,
			onChildStateChange: (changedChild) => {
				if (changedChild.getState() === 1) {
					$.each(this.children, (index, child) => {
						if (child.getId() !== changedChild.getId()) {
							child.deactivate();
						}
					});
				}
				this.fireEvent('filter-change', this);
				this.redraw();
			},
			postUpdateChildren: () => {
				let activeCount = this.children.reduce((total, child) => {
					if (child.getState() === 1 && !child.parentStateIgnore) {
						total = total + 1;
					}
					return total;
				}, 0);
				if (activeCount === 0) {
					this.setDefaultChild();
				}
			},
			setDefaultChild: () => {
				$.each(this.children, (index, child) => {
					if (child.defaultSelected) {
						child.activate();
					}
				});
			},
			setTypeData: (rawData) => {
				this.expanded = rawData.expanded;
			},
			typeTemplateData: () => {
				return {
					expanded: this.expanded,
				};
			},
			bindListeners: () => {
				$(document).on('show.bs.collapse', '#collapse-' + this.id, () => {
					this.expanded = true;
				});
				$(document).on('hide.bs.collapse', '#collapse-' + this.id, () => {
					this.expanded = false;
				});
			},
		};

		Object.assign(this, instanceVars);
		this.init(rawData);
		return this;
	}

	function ResponseList() {
		let instanceVars = {
			containerId: 'items-container',
			items: {},
			order: [],
			selected: null,
			init: () => {
				this.bindListeners();
			},
			add: (item) => {
				this.order.push(item.getProjectId());
				this.items[item.getProjectId()] = item;
			},
			first: () => {
				let all = this.all();
				if (all.length > 0) {
					return all[0];
				}
				return null;
			},
			all: () => {
				return $.map(this.order, (projectId) => {
					return this.items[projectId];
				});
			},
			render: () => {
				let toRender = [];
				$.each(this.all(), (index, item) => {
					if (this.selected === null && index === 0) {
						this.setSelected(item.getProjectId(), false);
					}
					if (!item.isRendered()) {
						toRender.push(item.html());
					}
				});
				this.getContainer().append(toRender.join('\n'));
			},
			reset: () => {
				this.getContainer().empty();
				this.items = {};
				this.order = [];
				this.selected = null;
			},
			setSelected: (projectId, fireEvent) => {
				if (typeof fireEvent === 'undefined') {
					fireEvent = true;
				}
				if (this.selected) {
					this.findItem(this.selected).setSelected(false).redraw();
				}
				this.findItem(projectId).setSelected();
				this.selected = projectId;
				if (fireEvent) {
					this.fireEvent('change-selected', this.selected);
				}
			},
			findItem: (projectId) => {
				return this.items[projectId];
			},
			getContainer: () => {
				return $('#' + this.containerId);
			},
			bindListeners: () => {
				this.getContainer().on('click', '.responses-projects-item', (e) => {
					e.preventDefault();
					let targetId = $(e.currentTarget).data('project-id');
					this.setSelected(targetId);
					hideAndResetInvoiceGeneratorForm?.();
				});
			},
		};

		Object.assign(this, instanceVars, PubSub);
		this.init();
		return this;
	}

	function Fetcher(
		filters,
		stickyProjectId,
		unreadOnly,
		initialLoadShouldBeViewAllTab = false,
	) {
		let instanceVars = {
			filters: null,
			fetchActive: false,
			countActive: false,
			filteredTotal: 0,
			resultCount: 0,
			unfilteredTotal: 0,
			filtered: false,
			lastFetched: null,
			nextRef: null,
			currentPage: 0,
			lastPage: 0,
			stickyProjectId: null,
			loaderClass: 'loading-more-records',
			headerContainerId: 'items-header',
			headerTemplate: itemsHeaderTemplate,
			sinceValueClass: 'since-value',
			sinceFetchInterval: null,
			countUpdateTimeout: null,
			clearFiltersLinkClass: showNewHeader
				? 'js-clear-filters-button'
				: 'clear-all-filters',
			showNewHeader,
			tabFilter: initialLoadShouldBeViewAllTab ? null : 'Live',
			init: (filters, stickyProjectId) => {
				filters.on(['filters-update', 'keyword-update'], () => {
					clearTimeout(this.countUpdateTimeout);
					this.countUpdateTimeout = setTimeout(this.updateCount, 500);
				});
				this.stickyProjectId = stickyProjectId ? stickyProjectId : false;
				this.unreadOnly = unreadOnly ? unreadOnly : false;
				this.filters = filters;
				this.bindListeners();
				triggerEnquiriesBanner({
					pagename: window.location.pathname,
					number_of_responses: $('.responses-projects-item').length,
				});
			},
			get: (fetchProcessor) => {
				this.abort('fetch');
				this.showLoader();
				let payload = filters.getSearchPayload();
				payload['show_filter_counts'] = true;
				if (this.nextRef) {
					payload['next_page'] = this.nextRef;
				}
				if (!this.lastFetched && this.stickyProjectId) {
					payload['project_ids'] = [this.stickyProjectId];
				}
				// if we want to initially get only unread we will set that here
				if (this.unreadOnly) {
					payload['project'] = ['unread'];
				}

				//Apply response status filter from tab
				if (this.tabFilter) {
					payload['response_status'] = [this.tabFilter];
				}

				this.fetchActive = Bark.api(
					'seller/responses/',
					payload,
					(fetchData) => {
						this.fetchActive = false;
						this.lastFetched = moment();
						let { data } = fetchData;
						this.resultCount = data?.total ?? 0; // Count of results, with filters applied if they are
						this.filteredTotal = data?.response_statuses_count ?? 0; // Per tab: pending vs archived, how many results are there, ignoring filters?
						this.unfilteredTotal = data?.unfiltered_total ?? 0; // How many results are there, ignoring all filters and tabs

						this.filters.set(data.filters);
						// if unreadOnly was set we need to find the checkbox and mark it aswell as remove the unreadOnly
						// for any subsequent calls as this will be handled by the filters in future calls
						if (this.unreadOnly) {
							this.filters.findAndSet('viewed_unread_checkbox', true);
							this.unreadOnly = false;
						}
						this.filtered = this.filters.hasFilterData();
						if (this.resultCount === 0) {
							this.showNoResults();
							this.fireEvent('no-results');
						} else {
							this.fireEvent('has-results', this);
						}
						this.nextRef = data.current_page + 1 < data.last_page ? data.next_page : null;
						this.hideLoader();
						this.renderListHeader();
						this.bindHeaderListeners();

						fetchProcessor(data.items);
					},
					(error, exception) => {
						if (exception === 'abort') {
							return false;
						}
						this.fetchActive = false;
						this.hideLoader();
					},
					'GET',
					{ Accept: 'application/vnd.bark.v2+json' },
				);
			},
			updateCount: () => {
				this.abort('count');
				let payload = filters.getSearchPayload();
				payload['show_filter_counts'] = true;
				payload['results_per_request'] = 0;

				//Apply response status filter from tab
				if (this.tabFilter) {
					payload['response_status'] = [this.tabFilter];
				}

				this.countActive = Bark.api(
					'seller/responses/',
					payload,
					(fetchData) => {
						this.countActive = false;
						let { data } = fetchData;
						this.filters.set(data.filters);
					},
					(error, exception) => {
						if (exception === 'abort') {
							return false;
						}
						this.countActive = false;
					},
					'GET',
					{ Accept: 'application/vnd.bark.v2+json' },
				);
			},
			abort: (handler) => {
				handler = handler + 'Active';
				if (this[handler]) {
					this[handler].abort();
					this[handler] = false;
				}
			},
			reset: (hideHeader) => {
				hideHeader ?? true;
				this.abort();
				this.stopFetchInterval();
				if (hideHeader) {
					this.getHeaderContainer().empty().addClass('d-none');
				}
				this.unfilteredTotal = 0;
				this.filteredTotal = 0;
				this.resultCount = 0;
				this.filtered = false;
				this.lastFetched = null;
				this.nextRef = null;
				this.currentPage = 0;
				this.lastPage = 0;
			},
			getHeaderContainer: () => {
				return $('#' + this.headerContainerId);
			},
			getResultsSummary: () => {
				const tabFilterLabel = this.getTabFilterLabel()
					? this.getTabFilterLabel().toLowerCase()
					: null;
				let resultsSummary;
				const filteredTotal = this.filteredTotal;
				const resultCount = this.resultCount;

				if (this?.showNewHeader ?? false) {
					let translationStringKey;
					if (this.isFiltered()) {
						translationStringKey =
							'seller_responses:filters-bar.filtered.showing-x-of-y-responses';
						resultsSummary = _t(translationStringKey, {
							count: filteredTotal, // "...of 123 responses"
							number_of_filtered_responses: resultCount, // "Showing 15..."
							response_type: tabFilterLabel,
						});
					} else {
						translationStringKey = 'seller_responses:filters-bar.unfiltered.show-all';
						resultsSummary = _t(translationStringKey, {
							count: resultCount, // "Showing all 123 responses"
							response_type: tabFilterLabel,
						});
					}
				} else {
					resultsSummary = _t(
						'seller_responses:project-list.results-summary.results-summary',
						{
							count: resultCount,
							filter_label: this.getTabFilterLabel()
								? this.getTabFilterLabel().toLowerCase()
								: null,
						},
					);
				}
				return resultsSummary;
			},
			renderListHeader: () => {
				let templateData = {
					filtered: this.isFiltered(),
					updated_time_ago: this.getSinceString(),
					results_summary: this.getResultsSummary(),
				};

				isEnquiriesActive()
					.then((active) => {
						if (!active) {
							this.getHeaderContainer()
								.html(this.headerTemplate(templateData))
								.removeClass('d-none');
						} else {
							if (this.getHeaderContainer().html().trim() === '') {
								this.getHeaderContainer()
									.html(this.headerTemplate(templateData))
									.removeClass('d-none');
							} else {
								this.getHeaderContainer()
									.find('.response-status-tabs-container')
									.html(
										$(this.headerTemplate(templateData))
											.filter('.response-status-tabs-container')
											.html(),
									);
								this.getHeaderContainer()
									.find('.results-count')
									.html(
										$(this.headerTemplate(templateData)).filter('.results-count').html(),
									);
							}
							this.getHeaderContainer().removeClass('d-none');
							this.enquiriesToggleInit();
						}
					})
					.catch(() => {
						this.getHeaderContainer()
							.html(this.headerTemplate(templateData))
							.removeClass('d-none');
					})
					.finally(() => {
						this.bindHeaderListeners();
					});
				this.startFetchInterval();
			},
			startFetchInterval: () => {
				this.stopFetchInterval();
				this.sinceFetchInterval = setInterval(() => {
					$('.' + this.sinceValueClass).text(this.getSinceString());
				}, 5000);
			},
			stopFetchInterval: () => {
				clearInterval(this.sinceFetchInterval);
			},
			clearAllFilters: () => {
				this.filters.clearFilters();
				this.filters.fireEvent('filters-apply', this.filters);
				tracking('seller-leads-dashboard-&-responses', 'Filter - cleared', {
					pagename: window.location.pathname,
				});
			},
			hasMoreResults: () => {
				return this.nextRef !== null;
			},
			hideLoader: () => {
				this.getLoader().addClass('d-none');
			},
			showLoader: () => {
				this.getLoader().removeClass('d-none');
			},
			getLoader: () => {
				return $('.' + this.loaderClass);
			},
			isFiltered: () => {
				return this.filtered;
			},
			getSinceString: () => {
				return this.lastFetched.locale('responses').fromNowOrNow();
			},
			getTabFilterLabel: () => {
				switch (this.tabFilter) {
					case 'Live':
						return _t('seller_responses:project-list.header.filter-label.pending');
					case 'Hired':
						return _t('seller_responses:project-list.header.filter-label.hired');
					default:
						return null;
				}
			},
			//Show No responses page for each tab
			showNoResults: () => {
				let filterTemplate;
				// This isn't switching on a user-facing string; there are no i18n issues here, don't worry 😎
				// We are using this.tabFilter which is essentially an Enum
				switch (this.tabFilter) {
					case 'Live':
						filterTemplate = 'pending';
						break;
					case 'Hired':
						filterTemplate = 'hired';
						break;
					default:
						filterTemplate = 'view-all';
						break;
				}
				// For no responses on the pending tab, show view-all empty state
				if (this.tabFilter === 'Live' && this.unfilteredTotal === 0) {
					filterTemplate = 'view-all';
				}
				let noResultsHiredHtml = Handlebars.compile(
					document.getElementById(`no-results-${filterTemplate}`).innerHTML,
				);
				if ('pending' === filterTemplate) {
					noResultsHiredHtml = noResultsHiredHtml({
						subheader: _t('seller_responses:no-pending-results.subheader', {
							hired_link: `<a class="js-click-hired-tab" href="#">${_t(
								'seller_responses:no-pending-results.hired-link',
							)} </a>`,
							archived_link: `<a class="js-click-view-all-tab" href="#">${_t(
								'seller_responses:no-pending-results.archived-link',
							)}</a>`,
						}),
					});
				}
				$('#full-project-container').empty().append(noResultsHiredHtml);
				$('#dashboard-projects')
					.find('.mobile-no-results')
					.empty()
					.append(noResultsHiredHtml);
				$('#main-project-container').addClass('bg-grey-25');
				this.bindNoResultsListeners();
			},
			bindNoResultsListeners: () => {
				if ($('.js-click-hired-tab').length) {
					$('.js-click-hired-tab').on('click', (e) => {
						e.preventDefault();
						$('#response-hired').trigger('click');
					});
				}

				if ($('.js-click-view-all-tab').length) {
					$('.js-click-view-all-tab').on('click', (e) => {
						e.preventDefault();
						$('#response-view-all').trigger('click');
					});
				}
			},
			bindHeaderListeners: () => {
				this.updateTabActiveClass();

				$('#response-live').on('click', (e) => {
					this.changeTabFilter('Live', e);
					hideAndResetInvoiceGeneratorForm?.();
				});

				$('#response-hired').on('click', (e) => {
					this.changeTabFilter('Hired', e);
					hideAndResetInvoiceGeneratorForm?.();
				});

				$('#response-view-all').on('click', (e) => {
					this.changeTabFilter(null, e);
					hideAndResetInvoiceGeneratorForm?.();
				});
			},
			enquiriesSettings: null,
			enquiriesToggleId: '.enquiries-toggle',
			enquiriesToggleInit: function () {
				if (!$('.js-enquiries-switch').hasClass('d-none')) {
					return;
				}
				let page = 'my responses';
				Bark.api(
					'lead-settings/enquiry-settings',
					{},
					({ data }) => {
						this.enquiriesSettings = data.find((settings) => {
							return (
								settings.attributes.name === 'active' &&
								settings.type === 'enquiry_settings'
							);
						});
						if (this.enquiriesSettings) {
							$('.js-enquiries-switch').removeClass('d-none');
							$('.js-enquiries-switch .toggle-icon').addClass('d-none');
							this.enquiriesSettings.attributes.value
								? $('.enquiries-branded').removeClass('d-none')
								: $('.enquiries-branded-greyed').removeClass('d-none');
							$(this.enquiriesToggleId).prop(
								'checked',
								this.enquiriesSettings.attributes.value,
							);
						}
					},
					() => {},
					'GET',
				);

				$(this.enquiriesToggleId)
					.off('change.enquiries')
					.on('change.enquiries', (event) => {
						let enquiriesToggleId = $(event.target);
						Bark.api(
							'lead-settings/enquiry-settings',
							JSON.stringify({
								id: this.enquiriesSettings?.id,
								name: this.enquiriesSettings?.attributes.name,
								value: event.target.checked ? true : false,
							}),
							() => {
								this.enquiriesSettings.attributes.value = event.target.checked;
								enquiriesToggleId.prop(
									'checked',
									this.enquiriesSettings.attributes.value,
								);
								$('.js-enquiries-switch .toggle-icon').addClass('d-none');
								this.enquiriesSettings.attributes.value
									? $('.enquiries-branded').removeClass('d-none')
									: $('.enquiries-branded-greyed').removeClass('d-none');
								tracking(
									'Enquiries-&-responses',
									(event.target.checked ? 'enable' : 'disable') + ' auto-purchase',
									{
										page: page,
										seller_profile_id: window?.Bark?.USER?.hashed_seller_profile_id,
									},
								);
							},
							() => {},
							'PUT',
							{},
							false,
							'application/json',
						);
					});

				$(`.js-enquiries-switch .enquiries-edit`).click((e) => {
					tracking('Enquiries-&-responses', ' select edit', {
						page: page,
						seller_profile_id: window?.Bark?.USER?.hashed_seller_profile_id,
					});
					window.location = _l('/settings/enquiries/profiles/view');
				});
			},
			updateTabActiveClass: () => {
				$('.response-status-tabs-container').find('.active').removeClass('active');
				switch (this.tabFilter) {
					case 'Live':
						$('#response-live').addClass('active');
						break;
					case 'Hired':
						$('#response-hired').addClass('active');
						break;
					default:
						$('#response-view-all').addClass('active');
				}
			},
			changeTabFilter: (value, event) => {
				if (this.tabFilter !== value) {
					event.preventDefault();
					event.stopPropagation();
					$('#main-project-container').removeClass('bg-grey-25');
					$('#dashboard-projects').find('.mobile-no-results').empty();
					this.tabFilter = value;
					this.updateTabActiveClass();
					this.clearAllFilters();
					tracking('responses-dashboard', 'View my responses', {
						tab: this.getTabFilterLabel() ? this.getTabFilterLabel() : 'all_leads',
					});
				}
			},
			bindListeners: () => {
				this.getHeaderContainer().on('click', '.' + this.clearFiltersLinkClass, (e) => {
					e.preventDefault();
					this.clearAllFilters();
				});
			},
		};

		Object.assign(this, PubSub, instanceVars);
		this.init(filters, stickyProjectId);
		return this;
	}

	function Filters() {
		let instanceVars = {
			modalContainerId: 'dashboard-sidebar-modal',
			modalTemplate: filtersModal,
			clearFiltersLinkClass: 'clear-all-filters',
			filtersApplyLinkClass: 'filter-results',
			filtersRevertLinkClass: 'filter-revert',
			keywordSearchId: 'keyword-search',
			keywordClearClass: 'clear-input',
			filters: [],
			rendered: false,
			keyword: '',
			originalKeyword: '',
			set: (filterData) => {
				$.each(filterData, (index, filterGroup) => {
					let obj = null;
					switch (filterGroup.type) {
						case 'header':
							obj = HeaderFilter;
							break;
						case 'header_radio':
							obj = HeaderRadioFilter;
							break;
						default:
							return false;
							break;
					}
					let foundFilter = this.filterExists(filterGroup.id);
					if (foundFilter) {
						foundFilter.update(filterGroup);
					} else {
						let filter = new obj(filterGroup);
						filter.on('filter-change', () => {
							this.fireEvent('filters-update', this);
						});
						this.filters.push(filter);
					}
				});
				if (!this.rendered) {
					this.renderModal();
				} else {
					this.redraw();
				}
			},
			findAndSet: (filterId, activate) => {
				let filter = this.filterExists(filterId, true);
				if (!filter) {
					return;
				}
				if (activate) {
					filter.activate();
				} else {
					filter.deactivate();
				}
				filter.redraw();
			},
			onFiltersUpdate: () => {
				if (this.hasFilterData(true)) {
					this.showClearFiltersLink();
				} else {
					this.hideClearFiltersLink();
				}
			},
			filterExists: (filterId, includeChildren) => {
				includeChildren = includeChildren ? includeChildren : false;
				let foundFilter = null;
				$.each(this.filters, (index, filter) => {
					if (filter.getId() === filterId) {
						foundFilter = filter;
					} else if (includeChildren) {
						let childFilter = filter.childExists(filterId);
						if (childFilter) {
							foundFilter = childFilter;
						}
					}
				});
				return foundFilter;
			},
			getSearchPayload: (ignoreDefault) => {
				if (typeof ignoreDefault === 'undefined') {
					ignoreDefault = false;
				}
				let payload = {};
				if (this.hasKeyword()) {
					payload['search'] = this.keyword;
				}
				$.each(this.filters, (index, filter) => {
					payload = {
						...payload,
						...filter.getFilterData(ignoreDefault),
					};
				});
				return payload;
			},
			hasFilterData: () => {
				return Object.keys(this.getSearchPayload(true)).length > 0;
			},
			getModalContainer: () => {
				return $('#' + this.modalContainerId);
			},
			templateData: () => {
				return {};
			},
			apply: () => {
				this.originalKeyword = this.keyword;
				$.each(this.filters, (index, filter) => {
					filter.apply();
				});
			},
			revert: () => {
				this.setKeyword(this.originalKeyword);
				$.each(this.filters, (index, filter) => {
					filter.revert();
					this.fireEvent('filters-update', this);
				});
			},
			redraw: () => {
				$.each(this.filters, (index, filter) => {
					filter.redraw();
				});
			},
			setKeyword: (newKeyword) => {
				this.keyword = newKeyword;
				$('#' + this.keywordSearchId).val(this.keyword);
				if (this.hasKeyword()) {
					this.showKeywordClear();
				} else {
					this.hideKeywordClear();
				}
				this.fireEvent('keyword-update', this);
			},
			hasKeyword: () => {
				return this.keyword.length > 0;
			},
			getKeywordClearElement: () => {
				return $('#' + this.keywordSearchId + '+' + '.' + this.keywordClearClass);
			},
			showKeywordClear: () => {
				this.getKeywordClearElement().removeClass('d-none');
			},
			hideKeywordClear: () => {
				this.getKeywordClearElement().addClass('d-none');
			},
			clearFilters: () => {
				this.setKeyword('');
				$.each(this.filters, (index, filter) => {
					filter.deactivateAll();
				});
				this.apply();
				this.fireEvent('filters-update', this);
			},
			renderFilters: () => {
				return $.map(this.filters, (filter) => {
					return filter.render();
				}).join(' ');
			},
			html: () => {
				let templateData = {
					...this.templateData(),
					filter_html: this.renderFilters(),
				};
				return this.modalTemplate(templateData);
			},
			renderModal: () => {
				this.getModalContainer().html(this.html());
				this.bindListeners();
				this.rendered = true;
			},
			showClearFiltersLink: () => {
				this.getModalContainer()
					.find('.' + this.clearFiltersLinkClass)
					.removeClass('d-none');
			},
			hideClearFiltersLink: () => {
				this.getModalContainer()
					.find('.' + this.clearFiltersLinkClass)
					.addClass('d-none');
			},
			bindListeners: () => {
				this.on(['filters-update', 'keyword-update'], this.onFiltersUpdate);
				this.getModalContainer().on('click', '.' + this.clearFiltersLinkClass, (e) => {
					e.preventDefault();
					this.clearFilters();
				});
				this.getModalContainer().on('click', '.' + this.filtersApplyLinkClass, (e) => {
					this.apply();
					this.getModalContainer().modal('hide');
					this.fireEvent('filters-apply', this);
					let filterData = this.getSearchPayload(true);
					let trackingArgs = Object.keys(filterData).reduce(
						(appliedFilters, currentFilterKey) => {
							if (
								currentFilterKey !== 'show_filter_counts' &&
								currentFilterKey !== 'next_page' &&
								filterData[currentFilterKey]
							) {
								appliedFilters.filter_names.push(currentFilterKey);
								appliedFilters.filter_values.push(
									`${currentFilterKey}: ${filterData[currentFilterKey]}`,
								);
							}
							return appliedFilters;
						},
						{ filter_names: [], filter_values: [] },
					);
					tracking('seller-leads-dashboard-&-responses', 'Filters - apply', {
						filter_names: trackingArgs.filter_names.toString(),
						filter_values: trackingArgs.filter_values.toString(),
						pagename: window.location.pathname,
					});
				});
				this.getModalContainer().on('click', '.' + this.filtersRevertLinkClass, (e) => {
					this.revert();
					this.getModalContainer().modal('hide');
				});
				this.getModalContainer().on('keyup', '#' + this.keywordSearchId, (e) => {
					this.setKeyword($(e.currentTarget).val());
				});
				this.getModalContainer().on('click', '.' + this.keywordClearClass, (e) => {
					e.preventDefault();
					$('#' + this.keywordSearchId).val('');
					this.setKeyword('');
				});
				this.getModalContainer().on('hide.bs.modal', (e) => {
					this.revert();
				});
			},
		};

		Object.assign(this, PubSub, instanceVars);
		return this;
	}

	let instanceVars = {
		filters: null,
		list: null,
		project: null,
		initialised: false,
		viewingProject: false,
		containerId: 'responses-container',
		moreLinkContainerClass: 'load-more',
		loaderClass: 'project-details-loader',
		refreshLinkClass: showNewHeader ? 'js-filter-list-refresh-button' : 'refresh-link',
		filtersLinkClass: showNewHeader ? 'js-edit-filters-button' : 'open-filters-link',
		filterModalId: 'dashboard-sidebar-modal',
		noResultsContainerId: 'no-results-container',
		resultsContainerId: 'responses-result-container',
		clearFiltersLinkClass: showNewHeader
			? 'js-clear-filters-button'
			: 'clear-all-filters',
		enquiriesToggleId: '.js-enquiries-switch',
		fullProjectContainerId: 'full-project-container',
		projectListContainerId: 'dashboard-projects',
		mainProjectContainerId: 'main-project-container',
		init: () => {
			let stickyProjectId = QS.getValue('prx', null);
			if (stickyProjectId) {
				this.trackEnquiriesSMS(stickyProjectId);
			}

			let unreadOnly = QS.getValue('show-unread', false);
			let initialLoadShouldBeViewAllTab =
				QS.getValue('responses_tab', false) === 'view-all';
			this.fireEvent('starting', this, (isMobile) => {
				if (isMobile) {
					if (stickyProjectId) {
						this.hideProjectList();
						this.showMainProject();
					} else {
						this.showProjectList();
						this.hideMainProject();
					}
				}
			});
			this.filters = new Filters();
			this.fetcher = new Fetcher(
				this.filters,
				stickyProjectId,
				unreadOnly,
				initialLoadShouldBeViewAllTab,
			);
			this.list = new ResponseList();
			this.list.on('change-selected', this.loadProject);
			this.showLoader();
			this.bindListeners();
			this.populate();
			this.initQuoteModal();
		},
		populate: () => {
			this.getMoreLinkContainer().css('display', 'none');
			this.fetcher.get(this.fetchProcessor);
		},
		refresh: () => {
			this.list.reset();
			// this.fetcher.stopFetchInterval();
			this.fetcher.reset();
			if (this.project) {
				this.project.clear();
			}
			this.showLoader();
			this.project = null;
			this.initialised = false;
			this.populate();
		},
		fetchProcessor: (fetchedItems) => {
			$.each(fetchedItems, (index, fetchedItem) => {
				if (!this.initialised && index === 0) {
					this.createProject(fetchedItem);
				}
				this.list.add(new SummaryItem(fetchedItem));
			});
			this.list.render();
			if (!this.initialised) {
				this.initialised = true;
				this.renderProject();

				if (this.project) {
					tracking('seller-leads-dashboard-&-responses', 'View response', {
						project_id: this.project.projectId,
						pagename: window.location.pathname,
						project_response_id: this.project.responseId,
						auto_selected: true,
					});
				}
			}
			if (this.fetcher.hasMoreResults()) {
				this.getMoreLinkContainer().css('display', 'block');
			} else {
				this.getMoreLinkContainer().css('display', 'none');
			}
		},
		showNoResults: () => {
			//Not used. showNoResults() on Fetcher used instead
			if (this.fetcher.isFiltered()) {
				this.getNoResultsContainer().addClass('has-filters');
			} else {
				this.getNoResultsContainer().removeClass('has-filters');
			}
			this.getResultsContainer().addClass('d-none');
			this.getNoResultsContainer().removeClass('d-none');
		},
		showResults: () => {
			this.getResultsContainer().removeClass('d-none');
			this.getNoResultsContainer().addClass('d-none');
		},
		hideLoader: () => {
			this.getLoader().addClass('d-none').removeClass('d-flex');
			this.getFullProjectContainer().removeClass('d-none');
		},
		showLoader: () => {
			this.getFullProjectContainer().addClass('d-none');
			this.getLoader().removeClass('d-none').addClass('d-flex');
		},
		getContainer: () => $('#' + this.containerId),
		getLoader: () => $('.' + this.loaderClass),
		getMoreLinkContainer: () => $('.' + this.moreLinkContainerClass),
		getFiltersModal: () => $('#' + this.filterModalId),
		getNoResultsContainer: () => $('#' + this.noResultsContainerId),
		getResultsContainer: () => $('#' + this.resultsContainerId),
		getFullProjectContainer: () => $('#' + this.fullProjectContainerId),
		getProjectListContainer: () => $('#' + this.projectListContainerId),
		getMainProjectContainer: () => $('#' + this.mainProjectContainerId),
		initQuoteModal: () => {
			Bark.sendEstimate &&
				Bark.sendEstimate.registerSuccessCallback((amount) => {
					window.modalManager.setBackdrop(true);
					window.modalManager.showSuccessModal(
						_t('seller_response_flow:estimate.estimate-sent'),
						'',
						2,
					);
					// Add or update the estimate amount
					$('.formatted-quote .quote').text(amount);
					$('.quote-cta-container .quote-link').text(
						_t('seller_responses:provide-quote-modal.update-button'),
					);
					this.fireEvent('estimate-updated', this);
					tracking(
						'seller-leads-dashboard-&-responses',
						'Send reference quote - success',
						{
							project_id: this.project.projectId,
							pagename: window.location.pathname,
							lead_type: 'project',
							project_response_id: this.project.responseId,
						},
					);
				});
		},
		trackEnquiriesSMS: (stickyProjectId) => {
			let utmMedium = QS.getValue('utm_medium', null);
			let campaign = QS.getValue('campaign', null);
			if (
				utmMedium &&
				campaign &&
				utmMedium.toLowerCase() === 'sms' &&
				campaign.toLowerCase() === 'seller-enquiries-callback' &&
				stickyProjectId
			) {
				tracking('seller-list-&-profile', 'enquiries - SMS link select', {
					seller_profile_id: window?.Bark?.USER?.hashed_seller_profile_id,
					project_id: stickyProjectId,
				});
			}
		},
		renderProject: () => {
			if (!this.project) {
				return false;
			}
			this.project.render();
			this.fireEvent('project-rendered', this, this.project);
			this.hideLoader();
			return true;
		},
		hideProjectList: () => {
			this.getProjectListContainer().addClass('d-none').removeClass('d-block');
		},
		showProjectList: () => {
			this.getProjectListContainer().addClass('d-block').removeClass('d-none');
		},
		hideMainProject: () => {
			this.getMainProjectContainer().addClass('d-none').removeClass('d-block');
		},
		showMainProject: () => {
			this.getMainProjectContainer().addClass('d-block').removeClass('d-none');
		},
		isViewingProject: () => this.viewingProject,
		createProject: (projectData) => {
			let project = new FullItem(projectData);
			project.on('back-to-list-clicked', () => {
				this.fireEvent('back-to-list', this, (isMobile) => {
					if (isMobile) {
						this.showProjectList();
						this.hideMainProject();
						//Response status has been updated. Trigger refresh to update the list
						if (project.responseStatusChanged) {
							this.fireEvent('response-status-changed');
						}
					}
				});

				this.viewingProject = false;
			});
			this.project = project;
			this.project.on('project-redraw', (project) => {
				if (this.project.projectId === project.projectId) {
					this.fireEvent('project-set', this, this.project);
				}
			});
			this.project.on('project-rendered', (project) => {
				if (this.project.projectId === project.projectId) {
					this.fireEvent('project-rendered', this, this.project);
					this.fireEvent('project-rendered-post-action', this, this.project);
				}
			});
			this.fireEvent('project-set', this, this.project);
			this.project.on('response-status-changed', () => {
				this.fireEvent('response-status-changed');
			});
		},
		loadProject: (projectId, postRender) => {
			this.fireEvent('show-project', this, (isMobile) => {
				if (isMobile) {
					this.hideProjectList();
					this.showMainProject();
				}
				this.viewingProject = true;
			});
			this.findProject(projectId, (projectData) => {
				this.createProject(projectData);
				this.renderProject();
				tracking('seller-leads-dashboard-&-responses', 'View response', {
					project_id: projectId,
					pagename: window.location.pathname,
					project_response_id: this.project.responseId,
					auto_selected: false,
				});
				if (typeof postRender !== 'undefined') {
					postRender();
				}
			});
		},
		findProject: (projectId, findProcessor) => {
			this.showLoader();
			Bark.api(
				'seller/response/' + projectId + '/',
				{},
				({ data }) => {
					findProcessor(data);
				},
				(error, exception) => {
					if (exception === 'abort') {
						return false;
					}
					this.hideLoader();
				},
				'GET',
				{ Accept: 'application/vnd.bark.v2+json' },
			);
		},
		showProjectDetails: (projectId) => {
			if (this.project.id !== projectId) {
				this.loadProject(projectId, () => {
					this.project.showDetails();
				});
			} else {
				this.project.showDetails();
			}
		},
		bindListeners: () => {
			this.filters.on('filters-apply', () => {
				this.refresh();
			});
			this.fetcher.on('no-results', () => {
				this.hideLoader();
			});
			this.fetcher.on('has-results', () => {
				this.showResults();
			});
			this.getMoreLinkContainer().on('click', 'button', this.populate);
			this.getContainer().on('click', '.' + this.refreshLinkClass, (e) => {
				e.preventDefault();
				const $refreshLink = $('.' + this.refreshLinkClass);
				if ($refreshLink.is(':disabled')) {
					// No op
				} else {
					$refreshLink.prop('disabled', true).addClass('disabled-refresh-button');
					this.refresh();
					tracking('seller-leads-dashboard-&-responses', 'Refresh dashboard', {
						pagename: window.location.pathname,
					});
					setTimeout(function () {
						$refreshLink.prop('disabled', false).removeClass('disabled-refresh-button');
					}, 3000); //To avoid button mashing
				}
			});
			this.getContainer().on('click', '.' + this.filtersLinkClass, (e) => {
				e.preventDefault();
				this.getFiltersModal().modal('show');
				tracking('seller-leads-dashboard-&-responses', 'Filters - view', {
					pagename: window.location.pathname,
				});
			});
			this.getNoResultsContainer().on('click', '.' + this.clearFiltersLinkClass, (e) => {
				e.preventDefault();
				this.fetcher.clearAllFilters();
			});
		},
	};

	Object.assign(this, PubSub, instanceVars);
	return this;
}
